import React from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { IoIosArrowDown } from 'react-icons/io';
import { mask } from 'remask';
import { Scroll } from '../../layout_components/scroll';
import { FormGroup } from '../group';

import {
  Arrow,
  Container,
  Input,
  Label,
  Legend,
  Option,
  OptionsList,
  OuterContainer,
} from './styles';

interface SelectItem {
  value: string | number;
  label: string;
}

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  items?: SelectItem[];
  masks?: string[];
  label?: string | null;
  error?: string | null;
}

const InputSelect: React.FC<Props> = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const ref = React.useRef<HTMLInputElement>(null);

  const handle_change = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { onChange, masks } = props;

    if (masks) {
      e.currentTarget.value = mask(e.currentTarget.value, masks);
    }

    if (onChange) {
      onChange(e);
    }
  };

  const handle_select = (value: string | number) => {
    setIsOpen(false);

    if (ref.current) {
      ref.current.focus();
      ref.current.value = value.toString();
    }
  };

  const toggle_options = React.useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  return (
    <>
      {isOpen && <OuterContainer onClick={toggle_options} />}
      <Container>
        <Label>
          {props.label}
          {props.required && <Legend>*</Legend>}
        </Label>

        <FormGroup>
          <Input
            {...props}
            ref={ref}
            error={Boolean(props.error)}
            onChange={handle_change}
            onClick={toggle_options}
            autoComplete='off'
          />

          <Arrow className={isOpen ? 'active' : ''}>
            <IoIosArrowDown />
          </Arrow>

          {isOpen && (
            <OptionsList>
              <Scroll column scroll-auto>
                {props.items?.map((item, index) => (
                  <Option key={index} onClick={() => handle_select(item.value)}>
                    {item.label}
                  </Option>
                ))}
              </Scroll>
            </OptionsList>
          )}
        </FormGroup>

        {props.error && (
          <Legend>
            <AiOutlineInfoCircle />
            {props.error}
          </Legend>
        )}
      </Container>
    </>
  );
};

export { InputSelect };
export type { SelectItem };
